import { useQuery } from "@tanstack/react-query";
import { getRoomTypes } from "../../api";

export const useGetRoomTypes = () => {
  const query = useQuery({
    queryKey: ["room-types"],
    queryFn: getRoomTypes,
  });

  return { ...query, data: query.data?.data };
};
